// extracted by mini-css-extract-plugin
export default {"myInput":"MyInput_myInput__s6Bq5"};